import Modal from 'bootstrap/js/dist/modal';
import { get } from 'svelte/store';
import { getAppConfig } from '../../../common/config/app-config';
import { APP_CONSTANTS, getBaseWebServiceUrl } from '../../../common/config/app-constants';
import { httpGetJSON, httpPostJSON, httpPostRaw } from '../../../common/services/ajax-services';

import { rrGetPDPPagePlacements } from '../../../common/services/rich-relevance';
import { algoliaClient, algoliaIndexConfig } from '../../../common/store/algolia-config-store';
import {
  convertJsonObjectToFormData,
  getCountryFullnameEn,
  getLangSpecificFieldname,
  getStr,
  JoodMembershipType,
  parseCashback,
  parsePriceString,
} from '../../../common/util';
import { showSnackbar } from '../../common/store/snackbar_store';
import { addToWishlist, removeFromWishlist } from '../../home/services/home-data-services';
import {
  addToCartContent,
  currentLocation,
  currentProductImage,
  flixMediaDataAvailabilityChecked,
  flixMediaDataAvailable,
  giftCardAmount,
  giftcardemail,
  giftcardmsg,
  giftPopupForCart,
  hightlightDetailsClickOnSlideIndex,
  isReviewSectionExpanded,
  isTTL24DataAvailable,
  nearestPickupStore,
  openAddToCartDrawer,
  pdpJoodBenefitInfo,
  pdpServicesData,
  productDetails,
  productImages,
  productQuantity,
  qacAtcPopupFlag,
  qacProductCode,
  rsaBrand,
  rsaPlateNo,
  rsaYear,
  selectedGifts,
  sellerOfferId,
  servicesInfo,
  shouldPDPGiftOptionReset,
  showHighlightDetailsPopup,
  showPdpMoreInfoModal,
  showPdpTileInfo,
  testFreakData,
} from '../store/pdp_store';

import { environment } from '../../../../environment/env';
import { getCommonPdpMixpanelData } from './pdp-mixpanelData';
const {
  lang = 'en',
  countryCode,
  encodedContextPath,
  CSRFToken,
  jessionId,
  userSelectedCity,
  userDefaultCityCode,
  currencyIso,
  primeEnabled,
  primeLevel,
  svelteATCEnabled,
  pageId,
  pageType,
  joodExpiredFlag,
} = getAppConfig();
const { tasheelInfo } = window['ACC'].config.unbxdSearchConfig;

const BASE_WEB_SERVICE_URL = getBaseWebServiceUrl();
const rsa_selectCarBrand = getStr('extra.pdp.rsa.Selectbrand');
const rsa_selectYear = getStr('extra.pdp.rsa.Selectyear');
const rsa_enterPlateNum = getStr('extra.pdp.rsa_enterPlateNum');
const rsa_incorrectPlateNum = getStr('extra.pdp.rsa_incorrectPlateNum');
const RSAErrMsgAr = [rsa_selectCarBrand, rsa_selectYear, rsa_enterPlateNum, rsa_incorrectPlateNum];
const itemRemoveMsg = getStr('extra.pdp.itemRemoveMsg');
const itemAddedMsg = getStr('extra.pdp.itemAddedMsg');
const flixAvailabilityRequests = new Map<string, Promise<boolean>>();
let activeFlixProductKey;
// Get the algolia query id from URL

export function processRRHits(rr) {
  const processed = Object.assign({}, rr);
  processed.hits = processed.hits.map(hit =>
    Object.assign({}, hit, {
      name: hit[getLangSpecificFieldname('name', lang)],
      price: {
        formattedValue: parsePriceString(hit.wasPrice, countryCode),
        value: hit.wasPrice,
      },
      aftreCashBackPrice: hit.hasCashBack
        ? {
            formattedValue: parsePriceString(hit.price - +parseCashback(hit.cashback, countryCode), countryCode),
          }
        : {
            formattedValue: parsePriceString(hit.price, countryCode),
          },
      cashBackPrice: parseCashback(hit.cashback, countryCode),
      productStatus: hit[getLangSpecificFieldname('productStatus', lang)],
      productStatusHtml: hit[getLangSpecificFieldname('productStatusHtml', lang)],
      freeGiftQtuantities: hit.freegiftworth,
      percentageDiscount: {
        formattedValue: hit.priceValueDiscountPercentage.toString(),
        value: hit.priceValueDiscountPercentage,
      },
      discountPrice: {
        value: hit.priceValueDiscount,
        formattedValue: parsePriceString(hit.priceValueDiscount, countryCode),
      },
      url: hit[getLangSpecificFieldname('url', lang)],
      code: hit.productCode,
    })
  );

  return processed;
}

export function getAlgoliaDataForPlacements(placements) {
  const { productIndexKey } = get(algoliaIndexConfig);
  const queries = [];
  placements.forEach(data => {
    const obj = {
      indexName: productIndexKey,
      query: '*',
      params: {
        filters: `price>0`,
        facetFilters: [data.facetFilter],
      },
    };
    queries.push(obj);
  });

  return get(algoliaClient)
    .multipleQueries(queries)
    .then(data => {
      data.results = data.results.map((item, index) => {
        item.strategyMessage = placements[index].message;
        item.key = placements[index].key;
        item.hits = item.hits.map((i, _index) =>
          Object.assign({}, i, {
            rrClickTrackingURL: placements[index].items[_index].clickTrackingURL,
          })
        );
        return item;
      });
      return data.results;
    });
}

export async function processRRPlacements(placements) {
  if (placements && placements.length > 0) {
    placements = placements.map(data => {
      const facetFilter = [];
      data.items.forEach(recommendedData => facetFilter.push(`productCode:${recommendedData.id}`));
      data.facetFilter = facetFilter;
      data.key = data.placement_name.split('.')[1];
      return data;
    });

    return placements;
  }
  return [];
}

export async function pdpRichRelevance() {
  return rrGetPDPPagePlacements()
    .then(placements => processRRPlacements(placements))
    .then(placements => getAlgoliaDataForPlacements(placements));
}

export async function getTasheelCardDetails() {
  // const url = `${APP_CONSTANTS.APP_BASE_URL}/${getBaseWebServiceUrl()}/${APP_CONSTANTS.TasheelCardResp}`;
  // const response = await httpGetJSON(url, {} , false);
  // console.log(response , "TasheelCardResp");
}

export async function getProductImages(sku) {
  const url = `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL_S}${sku}_800.json`;
  const params = {
    deep: true,
  };
  const response = await httpGetJSON(url, params, {}, false);
  if (response.name && response.items.length) {
    productImages.set(response.items);
    const nVideos = response.items.filter(x => x.type === 'video').length;
    const nImages = response.items.length - nVideos;
    const hasVideo = nVideos > 0;
    setPDPViewedTotalImages(nImages, hasVideo);
    currentProductImage.set(response.items[0].src);
    return true;
  } else {
    setPDPViewedTotalImages(0, false);
    throw new Error(`ERROR fetching banner data`);
  }
}

/*
  Filter images array to prefer Arabic versions when available.
  If both EN and AR versions exist for an image, uses AR version.
  If only EN exists, uses EN version.
  Returns deduplicated array with AR versions preferred.
*/
export function filterImagesPreferArabic(images: any[], lang: string) {
  const imageMap = new Map();
  images.forEach(img => {
    const base = img.src.replace(/_ar$/, '');
    const existing = imageMap.get(base) || {};

    if (img.src.endsWith('_ar')) {
      existing.ar = img;
    } else {
      existing.en = img;
    }
    imageMap.set(base, existing);
  });

  const filteredImages = Array.from(imageMap.values())
    .map(pair => (lang === 'ar' ? pair.ar || pair.en : pair.en))
    .filter(Boolean);
  return filteredImages;
}

export async function getSiblingProdMain(sku) {
  const url = `${window['ACC'].config.encodedContextPath}/p/${sku}${APP_CONSTANTS.GETPRODUCT}`;

  const response = await httpGetJSON(url, {}, false);
  const tempArr = window['ACC'].config.productDetails;
  window['ACC'].config.productDetails = addOrReplace(tempArr, response);
  productDetails.set(addOrReplace(tempArr, response));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function setPDPViewedTotalImages(number_of_product_images: number, product_video_flag: boolean) {
  // setPDPViewedData({ number_of_product_images, product_video_flag });
}
export function setPDPViewedRatingData(rating: number, no_of_reviews: number) {
  setPDPViewedData({ extra_product_rating: rating, no_of_reviews });
}
export function setPDPViewedServicesData(serviceTabs) {
  const Service_eligible_flag = serviceTabs?.length > 0 ? 'Yes' : 'No';
  const Services_name_eligible = (serviceTabs?.map(t => t.labelEn) || []).join(', ') || 'NA';
  const Country = getCountryFullnameEn();
  const City = getAppConfig().currentCity?.nameEn || 'Unknown';

  setPDPViewedData({ Service_eligible_flag, Services_name_eligible, Country, City });
}
export function setPDPVariantData(data) {
  const _variant = [];
  if (data) {
    data.map(val => {
      val.variantValues.map(v1 => {
        _variant.push({ variant_name: val.name, value: v1.name });
      });
    });
  }
  setPDPViewedData({ variant: _variant });
}
export function setPDPViewedData(eventObjPartial) {
  const mpPageLoad = window['MIXPANEL'].config.mixPanelPageLoad;
  if (mpPageLoad) {
    mpPageLoad.eventObj = Object.assign({}, mpPageLoad.eventObj, eventObjPartial);
    if ('requireMoreData' in mpPageLoad) {
      mpPageLoad['requireMoreData'] -= 1;
    }
  }
  emitPDPViewedEventIfDataAvailable();
}
export function emitPDPViewedEventIfDataAvailable() {
  const mpPageLoad = window['MIXPANEL'].config.mixPanelPageLoad;
  if (mpPageLoad && 'requireMoreData' in mpPageLoad && mpPageLoad['requireMoreData'] === 0) {
    // get sponsored flag from url
    const sponsored_flag = new URL(window.location.href).searchParams.get('sponsored') === 'true' ? 'Yes' : 'No';
    mpPageLoad.eventObj.sponsored_flag = sponsored_flag;
    mpPageLoad.eventObj.source = localStorage.getItem('productInSearchClicked')
      ? localStorage.getItem('productInSearchClicked')
      : window['ACC'].utils.getReferrer();
    mpPageLoad.eventObj.is_recommendation = window['ACC'].utils.getRecommendationFlag() ? 'Yes' : 'No';
    mpPageLoad.eventObj.is_chatbot = window['ACC'].utils.getChatBotFlag() ? 'Yes' : 'No';
    window['ACC'].mixpanel.track(mpPageLoad.eventName, mpPageLoad.eventObj);
  }
}

function addOrReplace(arr, newArr) {
  for (const main of Object.keys(arr)) {
    for (const subset of Object.keys(newArr)) {
      if (main === subset) {
        arr[main] = newArr[subset];
      }
    }
  }
  return arr;
}

export function getStyle(data, target) {
  if (target === 'title') {
    if (data?.includes('#')) {
      return `color:${data};`;
    } else {
      return `color: #FFFFFF;`;
    }
  }

  if (target === 'description') {
    if (data?.includes('#')) {
      return `color:${data};`;
    } else {
      return `color: #FFFFFF;`;
    }
  }
}

export async function notifyAlert({ email, mobileNo, alertType, productCode, CSRFToken, city }) {
  const body = `email=${email}&mobile=${mobileNo}&alertType=${alertType}&productCode=${productCode}&city=${city}&CSRFToken=${CSRFToken}`;
  const url = `${encodedContextPath}/${APP_CONSTANTS.NOTIFY_ALERT}`;

  return httpPostJSON(url, body, {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  });
}

export function showTileInfo(index) {
  hightlightDetailsClickOnSlideIndex.set(index);
  showPdpTileInfo.set(true);
  showHighlightDetailsPopup.set(true);
  if (typeof window['ACC']?.extragtm?.click?.pdpKeyHighlightClick === 'function') {
    window['ACC'].extragtm.click.pdpKeyHighlightClick();
  }
}

export async function getNearestLocation(data) {
  const url = `${getBaseWebServiceUrl()}/${APP_CONSTANTS.NEAREST_STORE}`;
  const { lang, jessionId } = getAppConfig();
  const params = {
    fields: 'FULL',
    lang,
    deviceId: jessionId,
    productCode: data.productCode,
    latitude: data.latitude,
    longitude: data.longitude,
  };
  const response = await httpGetJSON(url, params, false);
  if (response && !response?.errors?.length && response.displayName !== null) {
    nearestPickupStore.set(response);
  } else if (
    response &&
    response.errors.length &&
    (get(productDetails) as any)?.cfsPosPickUpInStoreData?.alternativePos?.displayName !== null
  ) {
    nearestPickupStore.set((get(productDetails) as any)?.cfsPosPickUpInStoreData?.alternativePos);
  } else {
    nearestPickupStore.set(null);
  }
}

export async function error() {
  currentLocation.set({});
  const pd = get(productDetails);
  if (pd?.cfsPosPickUpInStoreData?.alternativePos?.displayName?.length > 0) {
    nearestPickupStore.set(pd.cfsPosPickUpInStoreData?.alternativePos);
  } else {
    nearestPickupStore.set(null);
  }
}

export async function success(pos) {
  currentLocation.set(pos.coords);
  if ((get(currentLocation) as any).latitude !== null && (get(currentLocation) as any).longitude !== null) {
    const body = {
      productCode: (get(productDetails) as any)?.code || get(qacProductCode),
      latitude: (get(currentLocation) as any)?.latitude,
      longitude: (get(currentLocation) as any)?.longitude,
    };
    getNearestLocation(body);
  } else {
    if ((get(productDetails) as any).cfsPosPickUpInStoreData?.alternativePos?.displayName !== null) {
      nearestPickupStore.set((get(productDetails) as any).cfsPosPickUpInStoreData?.alternativePos?.displayName);
    } else {
      nearestPickupStore.set(null);
    }
  }
}

export async function postAddToCartData(body) {
  window['ACC'].loader.showLoader();
  const atcUrl = svelteATCEnabled ? APP_CONSTANTS.ADDTOCART_JSON : APP_CONSTANTS.ADDTOCART_HTML;
  const url = `${encodedContextPath}/${atcUrl}`;

  return httpPostJSON(url, body, {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  });
}

export async function getTasheelDetails() {
  const url = `${encodedContextPath}/${APP_CONSTANTS.GET_TASHEEL_DETAILS}`;
  return httpGetJSON(url, {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  });
}

export async function postAddBundleToCartData(body) {
  window['ACC'].loader.showLoader();
  const atcBundleUrl = svelteATCEnabled ? APP_CONSTANTS.ADDBUNDLETOCART_JSON : APP_CONSTANTS.ADDBUNDLETOCART_HTML;
  const url = `${encodedContextPath}/${atcBundleUrl}`;

  return httpPostJSON(url, body, {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  });
}

export const options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};

export function handleCartResponse(response) {
  const { minOrderQuantity } = get(productDetails);
  const min = minOrderQuantity ?? 1;
  const isATCSuccessful =
    (svelteATCEnabled && response?.productAdded) ||
    (!svelteATCEnabled && !!response?.addToCartLayer && !response?.errorMessage);
  if (isATCSuccessful) {
    productQuantity.updateQuantity(min);
    showPdpMoreInfoModal.set(false);
    const atcData = svelteATCEnabled ? response : response.addToCartLayer;
    addToCartContent.set(atcData);
    openAddToCartDrawer.set(true);
    if (
      pageId === 'homepage' ||
      pageId === 'productList' ||
      pageId === 'search' ||
      pageType === 'category' ||
      pageType === 'BRAND'
    ) {
      qacAtcPopupFlag.set(true);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } /* Below one is to intialize RR for addToCart popup*/
    window['ACC'].rrvariables.addToCartItemId = (get(productDetails) as any)?.code;
    window['ACC'].richrelevance?.onLoad('ADDTOCART');
    window['ACC'].extragtm.var.cartTotal = response?.cartData?.total ? response?.cartData?.total : response?.cartTotal;
    document.querySelector(window['ACC'].minicart.selector.miniCartTotal).innerHTML = response?.miniCartCount
      ? response?.miniCartCount
      : 0;
    // addToCartV2
    const bundleProdEntries = [];
    response?.modifications?.forEach(data => {
      data.entries.forEach(entry => {
        bundleProdEntries.push(entry.product);
      });
    });
    const gtmData = response?.entry?.product || response?.productDataForGtm;
    window['ACC'].extragtm.click.addToCartV2(bundleProdEntries.length > 0 ? bundleProdEntries : [gtmData]);

    window['ACC'].mixpanel.var.cartCode = response?.cartAnalyticsData
      ? response?.cartAnalyticsData?.code
      : response?.cartCode;
    setMixpanelData_PDPAddToCart(response?.entry?.product?.marketPlaceOfferData?.state ?? '');

    setTimeout(function () {
      const atcLayerDOM = document.getElementById('addToCartLayer').querySelector('#amp-page-slot7');
      const amplianceData = JSON.parse(
        atcLayerDOM?.getElementsByClassName('js-amp-config')[0]?.getAttribute('data-ampliance-option') || null
      );

      if (amplianceData) {
        window.AmpCa.utils = new window.AmpCa.Utils();
        window.AmpCa.utils.getHtmlServiceData({
          auth: {
            baseUrl: amplianceData.baseUrl,
            id: amplianceData.id,
            store: amplianceData.store,
            locale: amplianceData.locale,
            templateName: amplianceData.templateName,
          },
          callback: function (data) {
            document.getElementsByClassName('js-addtocart-ampliance-banner')[0].innerHTML = data;
            setupAddToCartTasheelBannerObserver(amplianceData);
          },
        });
      }
    }, 0);

    // Remove selected class from LMD services when add to cart popup is rendered
    const addToCartLmdServiceElements = document.querySelectorAll('.js-apply-lmd-service');

    if (addToCartLmdServiceElements?.length > 0) {
      // Iterate over LMD service elements and remove selected class
      addToCartLmdServiceElements.forEach(element => element.classList.remove('selected'));
    }
  } else if (response.errorMessage || response.errorMsg) {
    if (response.errorMessage) {
      showSnackbar(strip(response.errorMessage), 'error');
      productQuantity.updateQuantity(min);
    } else {
      if (response?.maxAddToCartQty !== null && response?.maxAddToCartQty > 0) {
        showSnackbar(getStr(response.errorMsg, [response?.maxAddToCartQty]));
        productQuantity.updateQuantity(response?.maxAddToCartQty);
      } else {
        showSnackbar(getStr(response.errorMsg), 'error');
        productQuantity.updateQuantity(min);
      }
    }
  } else {
    showSnackbar(strip(error), 'error');
    window['ACC'].loader.hideLoader();
  }
  if ((get(selectedGifts) as any).length) {
    selectedGifts.set([]);
  }
  window['ACC'].loader.hideLoader();
}

function setupAddToCartTasheelBannerObserver({ id }) {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        window['ACC'].extragtm.trackBannerView(id, 'Add to cart tasheel banner');
        window['ACC'].mixpanel.trackBannerView(id, 'Add to cart tasheel banner');
        io.unobserve(e.target);
      }
    });
  });

  setTimeout(() => {
    io.observe(document.querySelector('.js-addtocart-ampliance-banner'));
  }, 500);
}

export function giftCartPayload(detail) {
  const { giftSelected, giftGroupIndex } = detail;
  const vasSelections: any[] = get(pdpServicesData);
  console.log(detail);

  const dataObj = {
    sourceProductCode: (get(productDetails) as any).code,
    bundleProductCodes: (get(productDetails) as any).code,
    CSRFToken: getAppConfig().CSRFToken,
    hasFreeGift: (get(productDetails) as any).hasFreeGift ? true : false,
    ampProdImgSec: ['PDP-gift', 'PDP-popup-cartList'],
    pageId: getAppConfig().pageId,
    qty: getAppConfig().productQtyUpdateEnabled ? get(productQuantity) : 1,
    selectableGift:
      (get(productDetails) as any)?.freeGiftDataList[giftGroupIndex]?.freeGiftQtuantities?.sourceQty <
      (get(productDetails) as any)?.freeGiftDataList[giftGroupIndex]?.freeGiftQtuantities?.targetQty
        ? true
        : false,

    // vasSelections
    ...(vasSelections?.length > 0 && { vasSelections }),
  };
  if (giftSelected[0] === 'discount') {
    dataObj['acPriceDiscountSelected'] = true;
  } else {
    dataObj['fgProductCodes'] = giftSelected;
    dataObj['acPriceDiscountSelected'] = false;
    dataObj['freeGiftRuleId'] = (get(productDetails) as any)?.freeGiftDataList[giftGroupIndex]?.freeGiftRuleId;
  }

  const requestobjString = convertJsonObjectToFormData(dataObj);
  return requestobjString;
}

export function createBundlePayload(index) {
  let objectString = '';
  const dataObj = {
    bundleRuleId: (get(productDetails) as any)?.specialOfferDataList[index]?.bundleRuleId,
    sourceProductCode: (get(productDetails) as any)?.code,
    initialPrice: (get(productDetails) as any)?.specialOfferDataList[index]?.initialBundlePrice,
    targetBundlePrice: (get(productDetails) as any)?.specialOfferDataList[index]?.targetBundlePrice,
    CSRFToken: getAppConfig().CSRFToken,
    bundleProductCodes: [],
  };

  if ((get(productDetails) as any)?.specialOfferDataList[index]?.specialOfferProducts.length > 0) {
    (get(productDetails) as any)?.specialOfferDataList[index].specialOfferProducts.forEach(element => {
      dataObj.bundleProductCodes.push(element.code);
    });
  }

  for (const key in dataObj) {
    objectString += `${key}=${dataObj[key]}&`;
  }
  objectString += `CSRFToken=${getAppConfig().CSRFToken}`;
  return objectString;
}

export function isValidRsaForm(errMsgAr) {
  const rsaPlateNoValidation = /^([\u0660-\u0669a-zA-Z-\d]{1,15})$/;
  if (
    get(rsaBrand) &&
    get(rsaYear) &&
    get(rsaPlateNo) &&
    rsaPlateNoValidation.test(get(rsaPlateNo)) === true &&
    get(rsaPlateNo) &&
    get(rsaPlateNo).length <= 15
  ) {
    return 'true';
  } else {
    if (get(rsaBrand) == '') {
      // openSnackBar(errMsgAr[0]);
      // openSnackbar.update(x => x = false);
      showSnackbar(errMsgAr[0], 'error');
      return 'false';
    }
    if (get(rsaYear) == '') {
      // openSnackBar(errMsgAr[1]);
      // openSnackbar.update(x => x = false);
      showSnackbar(errMsgAr[1], 'error');

      return 'false';
    }
    if (get(rsaPlateNo) == '') {
      // openSnackBar(errMsgAr[2]);
      // openSnackbar.update(x => x = false);
      showSnackbar(errMsgAr[2], 'error');

      return 'false';
    }
    if (rsaPlateNoValidation.test(get(rsaPlateNo)) === false) {
      // openSnackBar(errMsgAr[3]);
      // openSnackbar.update(x => x = false);
      showSnackbar(errMsgAr[3], 'error');

      return 'false';
    }
  }
}
export function createRequestPayload() {
  const pd: any = get(productDetails);
  const vasSelections: any[] = get(pdpServicesData);
  const mpSellerOfferId = get(sellerOfferId) || pd?.marketPlaceOfferData?.id;
  const sourceType = window['ACC'].utils.getRecommendationFlag()
    ? window['ACC'].constants.sourceType.RECOMMENDATION
    : window['ACC'].utils.getChatBotFlag()
      ? window['ACC'].constants.sourceType.CHATBOT
      : null;

  const dataObject = {
    productCodePost: pd?.code,
    freeGiftNotAvailable: pd?.freeGiftNotAvailable,
    hasFreeGift: !!pd?.hasFreeGift,
    source: sourceType,
    CSRFToken,

    // vasSelections
    ...(vasSelections?.length > 0 && { vasSelections }),

    // purchasable dependent
    ...(pd?.purchasable && {
      qty: getAppConfig().productQtyUpdateEnabled ? get(productQuantity) : 1,
    }),
    ...(mpSellerOfferId && {
      offerId: mpSellerOfferId,
    }),

    // isRSAItem
    ...(pd?.isRSAItem && {
      carBrand: get(rsaBrand),
      carYear: get(rsaYear),
      plateNumber: get(rsaPlateNo),
    }),

    // isDigitalGiftCard
    ...(pd?.isDigitalGiftCard && {
      giftCardAmount: get(giftCardAmount),
      digitalGiftCard: true,
      giftCardReceiverEmailId: get(giftcardemail),
      giftCardMessage: get(giftcardmsg),
    }),

    // mirakl sponsored flag
    sponsored: isMiraklSponsoredPDP(),

    // RMN source PDP
    isRmnSourced: isRMNSourcedPDP(),
  };

  const objectString = convertJsonObjectToFormData(dataObject);

  return objectString;
}

export function closeGiftPopupAfterGiftSelection(data) {
  selectedGifts.set(data);
  document.querySelector('#giftModal').classList.remove('show');
  document.querySelector('body').classList.remove('modal-open');

  const mdbackdrop = document.querySelectorAll('.modal-backdrop');
  mdbackdrop.forEach(element => {
    element.classList.remove('modal-backdrop', 'show');
  });
  document.getElementById('giftModal').style.display = 'none';
}

export async function openSnackBar(msg) {
  // snackbarLabel.set(msg);
  // openSnackbar.update(x => x = true);
  window.ACC.main.showCouponCodeSnackbar('', false, msg);
}

export function strip(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent.trim() || '';
}

export function submitReviewToServer(review) {
  // test-freak test API
  const testFreaksHeaders = {
    'Content-Type': 'application/json',
  };
  const { CSRFToken } = getAppConfig();
  const url = `${encodedContextPath}/${APP_CONSTANTS.POST_TEST_FREAKS_REVIEW}?CSRFToken=${CSRFToken}`;
  const body = JSON.stringify({ review });

  return httpPostRaw(url, body, testFreaksHeaders, false);
}

export async function uploadReviewImageToServer(file: File) {
  const url = APP_CONSTANTS.TEST_FREAKS_IMAGE_UPLOAD_URL;
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Review image upload failed with status ${response.status}`);
  }

  return response.json();
}

export function manualBundleCartPayload(data) {
  const vasSelections: any[] = get(pdpServicesData);
  const dataObj = {
    sourceProductCode: (get(productDetails) as any).code,
    CSRFToken: getAppConfig().CSRFToken,
    bundleProductCodes: data,
    addManualBundleFreeGift: true,

    // vasSelections
    ...(vasSelections?.length > 0 && { vasSelections }),
  };
  const requestobjString = convertJsonObjectToFormData(dataObj);
  return requestobjString;
}

export function getTestFreakDataForProductId(productId) {
  const url = APP_CONSTANTS.GET_TEST_FREAK_BASE;

  const testFreaksHeaders = {
    'Content-Type': 'application/json',
  };

  return httpGetJSON(url, { key: productId, '-*': true }, testFreaksHeaders, false);
}

export function gtmForPdpService(event, category, family, productType, productName, brandName, sku, serviceName) {
  if (typeof window['ACC']?.extragtm?.click?.pdpServiceAction === 'function') {
    window['ACC'].extragtm.click.pdpServiceAction(
      event,
      category,
      family,
      productType,
      productName,
      brandName,
      sku,
      serviceName
    );
  }
}

export function getCategoryDetailsForPdp() {
  const categoryDetail = (get(productDetails) as any).categoryIdName;
  const [categoryId, categoryName] = categoryDetail.split('_');
  return { categoryId, categoryName };
}

export function gtmForGeekOutHeader(headerName, headerRank, highlightName) {
  if (typeof window['ACC']?.extragtm?.click?.geekOutHeaderClick === 'function') {
    window['ACC'].extragtm.click.geekOutHeaderClick(headerName, headerRank, highlightName);
  }
}

export function gtmForPdpSmallBox(name) {
  if (typeof window['ACC']?.extragtm?.click?.pdpSmallBoxClick === 'function') {
    window['ACC'].extragtm.click.pdpSmallBoxClick(name);
  }
}

export function generateArrayOfYears(count) {
  const year = new Date().getFullYear();
  const min = year - count;
  const years = [];

  for (let i = year; i >= min; i--) {
    years.push(i);
  }
  return years;
}

export function redirectToPdp(url: string) {
  if (url) {
    window.location.href = url;
  }
}

export function getSwogoBundleProducts(sku) {
  const url = `${APP_CONSTANTS.GET_SWOGO_BUNDLE}?skus=${sku}&longStyle=true`;

  return httpGetJSON(decodeURI(url), { '-*': true }, {}, false);
}

export async function getTamaraPriceForBundle(payload) {
  const url = `${getAppConfig().encodedContextPath}/${APP_CONSTANTS.GET_BUNDLE_TAMARA_PRICE}`;
  const body = {
    codes: payload,
  };
  const response = await httpGetJSON(url, body, {}, true);
  return response;
}

export async function getCartId() {
  const url = `${BASE_WEB_SERVICE_URL}/users/carts/`;

  const response = await httpGetJSON(url, {}, {}, true);
  return response;
}

export async function getAddToCartJson(cartId) {
  const url = `${BASE_WEB_SERVICE_URL}/users/carts/${cartId}/entries/`;
  // window['ACC'].loader.showLoader();
  const payload = `appId=${APP_CONSTANTS.APP_ID}&quantity=1&code=${
    (get(productDetails) as any).code
  }&freeGiftNotAvailable=true&fields=FULL&lang=en&city=${
    userSelectedCity || userDefaultCityCode
  }&AppSessionToken=${jessionId}`;
  return httpPostJSON(url, payload, {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  });
}

export function convertProductDataToUnbxdProductData(productData) {
  const convertedProductData = {
    ...productData,
    brandName: productData?.brandName
      ? productData.brandName
      : lang === 'en'
        ? productData.brandEn
        : productData.brandAr,
    name: productData?.name ? productData?.name : lang === 'en' ? productData?.nameEn : productData?.nameAr,
    price: {
      formattedValue: parseFloat(
        productData?.acPriceDiscount
          ? productData?.price?.formattedValue - productData?.acPriceDiscount
          : productData?.aftreCashBackPrice?.formattedValue ||
              productData?.discountPrice?.formattedValue ||
              productData?.price?.formattedValue
      ),
      currencyIso: currencyIso,
    },
    discountPrice: {
      formattedValue: parseFloat(productData?.discountPrice?.formattedValue),
    },
    wasPrice: parseFloat(productData?.price?.formattedValue),
    percentageDiscount: {
      formattedValue: productData.percentageDiscount?.value,
    },
    tasheelPriceData: {
      priceValueTasheel: {
        formattedValue:
          (productData && productData.priceValueTasheel && productData.priceValueTasheel) ||
          productData?.tasheelPriceData?.priceValueTasheel?.formattedValue,
        currencyIso: currencyIso,
      },
      tasheelInstallmentMonths: tasheelInfo && tasheelInfo?.tasheelInstallmentMonths,
      tasheelPercentage: tasheelInfo?.tasheelPercentage,
    },
    rating: productData.rating ?? 0,
    productTags: productData?.productTags?.length
      ? productData.productTags
      : productData?.productStatus
        ? [
            {
              label: productData?.productStatus,
              backgroundColorCode: '#FFECA1',
              textColorCode: '#051F2F',
            },
          ]
        : [],
    showAllFields: true,
    showBottomTags: true,
    showActionBtn: false,
    afterCashBackPrice: productData?.aftreCashBackPrice?.formattedValue
      ? productData?.aftreCashBackPrice?.formattedValue
      : null,
    cashBackPrice: productData?.cashBackPrice ? productData.cashBackPrice : null,
    basicPrimePrice: productData?.basicPrimePrice
      ? productData.basicPrimePrice
      : productData?.productBasicPrimeData
        ? productData?.productBasicPrimeData?.primePrice?.value
        : null,
    vipPrimePrice: productData?.vipPrimePrice
      ? productData.vipPrimePrice
      : productData?.productVipPrimeData
        ? productData?.productVipPrimeData?.primePrice?.value
        : null,
    primeEnabled: productData?.primeEnabled ? productData.primeEnabled : primeEnabled || false,
    primeLevel: productData?.primeLevel ? productData.primeLevel : primeLevel ? primeLevel : null,
    tacticalVipPromo: productData?.tacticalPromo
      ? productData.tacticalVipPromo
      : productData?.productVipPrimeData?.tacticalPromo
        ? productData?.productVipPrimeData?.tacticalPromo
        : false,
    tacticalBasicPromo: productData?.tacticalPromo
      ? productData.tacticalBasicPromo
      : productData?.productBasicPrimeData?.tacticalPromo
        ? productData?.productBasicPrimeData?.tacticalPromo
        : false,
    tacticalBasicPrimePrice: productData?.tacticalBasicPrimePrice
      ? productData?.tacticalBasicPrimePrice
      : productData?.productBasicPrimeData?.tacticalPrice?.formattedValue,
    tacticalVipPrimePrice: productData?.tacticalVipPrimePrice
      ? productData?.tacticalVipPrimePrice
      : productData?.productVipPrimeData?.tacticalPrice?.formattedValue,
    isProductInStock: 'stock' in productData && productData.stock.stockLevelStatus !== 'outOfStock',
    cashback: productData?.cashBackPrice,
    endDateJoodDay: productData?.endDateJoodDay || null,
    joodDayRemainingQuantity: productData?.joodDayRemainingQuantity || 0,

    smartFirstPrimePrice: productData?.productSmartPrimeData?.primePrice?.value,
    smartRepeatingPrimePrice: productData?.productSmartPrimeData?.primePrice?.value,
    tacticalSmartFirstPromo: productData?.productSmartPrimeData?.tacticalPromo,
    tacticalSmartRepeatingPromo: productData?.productSmartPrimeData?.tacticalPromo,
    tacticalSmartFirstPrimePrice: productData?.productSmartPrimeData?.tacticalPrice?.value,
    tacticalSmartRepeatingPrimePrice: productData?.productSmartPrimeData?.tacticalPrice?.value,
    smartFirstWalletCredits: productData?.productSmartPrimeData?.totalPrimeDiscount?.value,
    smartRepeatingWalletCredits: productData?.productSmartPrimeData?.totalPrimeDiscount?.value,
  };
  return convertedProductData;
}

export async function getServicesInfo(sku, vasGroup, isExploreLink) {
  const url = `${window['ACC'].config.encodedContextPath}/p/${sku}/vas/exploreFeatures?exploreAllPerks=${isExploreLink}&serviceTypes=${vasGroup}`;
  const response = await httpGetJSON(url, {}, {}, true);
  if (response && !response?.errors?.length && response.displayName !== null) {
    servicesInfo.set(response);
  } else {
    servicesInfo.set(null);
  }
}

export const isPreOrderDisabled = data => {
  return data?.homeDeliverystockOutOfStock;
};

export const isAddToCartDisabled = (data, cfsInStock) => {
  const { marketPlaceProduct } = get(productDetails);
  if (marketPlaceProduct) return !data?.stockStatus;
  return (
    !(data?.stockStatus && (data?.deliveryInStock || cfsInStock)) ||
    (data?.isDigitalGiftCard &&
      (!get(giftCardAmount) ||
        get(giftCardAmount) < data?.minGiftCardAmount ||
        get(giftCardAmount) > data?.maxGiftCardAmount))
  );
};
export const setMixpanelData_PDPAddToCart = (condition?: string) => {
  const { productDetails } = getAppConfig();
  const eventName = 'Added to Cart';
  const data = getCommonPdpMixpanelData(eventName);

  if (productDetails?.productStatus === 'PRE_ORDER') {
    window['ACC'].mixpanel.track('Pre Order Now', {
      ...data,
      ...(condition && { condition }),
    });
  }

  window['ACC'].mixpanel.track(eventName, {
    ...data,
    ...(condition && { condition }),
  });
};

export const setMixpanelData_AddToWishlist = () => {
  console.log('dataObj1');
  const data = getCommonPdpMixpanelData('Product Added to Wishlist');
  window['ACC'].mixpanel.track('Product Added to Wishlist', { ...data });
};
export const redirectToLocationHash = () => {
  const { hash } = location;

  if (!hash) return;

  setTimeout(() => {
    location.assign(hash);

    if (hash === '#reviews_section') {
      isReviewSectionExpanded.set(true);
    }
  }, 3000);
};

export const getTestFreakData = async () => {
  // const mpPageLoad = window['MIXPANEL'].config.mixPanelPageLoad;
  // if (mpPageLoad && typeof mpPageLoad.requireMoreData === 'number') {
  //   mpPageLoad.requireMoreData += 1;
  // }
  // console.log('[DBG] getTestFreakData', mpPageLoad);
  const tfData = await getTestFreakDataForProductId((get(productDetails) as any)?.code);

  if (tfData && !tfData.errors) {
    testFreakData.set(tfData);
    const rating = (tfData.score ?? 0) / 2;
    const nReviews = tfData.user_review_count ?? 0;
    setPDPViewedRatingData(rating, nReviews);
  } else {
    setPDPViewedRatingData(0, 0);
  }

  setPDPVariantData((get(productDetails) as any)?.productVariantGroups);
};

export const sendProductCartData = () => {
  const requestData = createRequestPayload();
  postAddToCartData(requestData)
    .then(response => {
      handleCartResponse(response);
    })
    .catch(error => {
      if (error) {
        console.log('failed', error);
      }
      window['ACC'].loader.hideLoader();
    });
};

export const rsaCheck = async () => {
  const rsaRes = await isValidRsaForm(RSAErrMsgAr);
  if (rsaRes === 'true') {
    sendProductCartData();
  } else {
    return;
  }
};

// Add Fixed Gift to Cart Payload
export const addFixedGiftToCartPayload = (fixedGift: any) => {
  const requestData = giftCartPayload(fixedGift);
  postAddBundleToCartData(requestData)
    .then(response => {
      handleCartResponse(response);
    })
    .catch(error => {
      if (error) {
        console.log('failed', error);
      }
      window['ACC'].loader.hideLoader();
    })
    .finally(() => {
      shouldPDPGiftOptionReset.set(true);
    });
};

// Add Gift to Cart Payload
export const addGiftToCartPayload = (event: any) => {
  const requestData = giftCartPayload(event.detail);
  postAddBundleToCartData(requestData)
    .then(response => {
      handleCartResponse(response);
      document.getElementById('giftModal').style.display = 'none';
    })
    .catch(error => {
      if (error) {
        console.log('failed', error);
      }
      window['ACC'].loader.hideLoader();
    })
    .finally(() => {
      shouldPDPGiftOptionReset.set(true);
    });
};

// Manual Bundle Payload
export const manualBundlePayload = (event: any) => {
  const requestData = manualBundleCartPayload(event.detail.prodsSelected);
  postAddBundleToCartData(requestData)
    .then(response => {
      handleCartResponse(response);
    })
    .catch(error => {
      if (error) {
        console.log('failed', error);
      }
      window['ACC'].loader.hideLoader();
    });
};

// Add Product to Cart Payload
export const addProductToCart = (
  isTransactional: boolean,
  hasFreeGift: boolean,
  freeGiftDataList: any[] | null,
  selectedGifts: string[],
  selectedGiftGroup: number,
  isRSAItem: boolean
): void => {
  if (!isTransactional) return;

  const _hasFreeGift = hasFreeGift && freeGiftDataList !== null;
  const _hasFixedFreeGift =
    _hasFreeGift &&
    freeGiftDataList.length === 1 &&
    freeGiftDataList[0].freeGiftQtuantities.sourceQty === freeGiftDataList[0].freeGiftQtuantities.targetQty &&
    !freeGiftDataList[0]?.acPriceDiscountValue;

  const _hasFixedDiscount =
    freeGiftDataList !== null &&
    freeGiftDataList.length === 1 &&
    freeGiftDataList[0].freeGiftQtuantities.sourceQty === freeGiftDataList[0].freeGiftQtuantities.targetQty &&
    freeGiftDataList[0].acPriceDiscountValue &&
    freeGiftDataList[0].freeGiftProducts === null;

  if (_hasFixedFreeGift || _hasFixedDiscount) {
    const fixedFreeGifts: string[] = [];
    if (freeGiftDataList[0]?.freeGiftProducts && freeGiftDataList[0]?.freeGiftProducts.length > 0) {
      freeGiftDataList[0]?.freeGiftProducts.forEach(element => {
        fixedFreeGifts.push(element.code);
      });
      addFixedGiftToCartPayload({ giftSelected: fixedFreeGifts, giftGroupIndex: 0 });
    } else if (_hasFixedDiscount) {
      fixedFreeGifts.push('discount');
      addFixedGiftToCartPayload({ giftSelected: fixedFreeGifts, giftGroupIndex: 0 });
    }
  } else if (_hasFreeGift) {
    if (selectedGifts.length === 0) {
      if (get(showPdpMoreInfoModal)) {
        showPdpMoreInfoModal.set(false);
      }
      giftPopupForCart.set(true);
      const element = document.getElementById('giftModal');
      //we are using the same component for pre order.
      //in preorder gift items listing in the page not in the popup
      //so we added the model classed based on the condition
      //when user not selecting any click in preorder, we have to show the popup, so we are adding the class manually
      const modelClass = 'giftModalLabel modal fade';
      const modelClassWrapper = 'modal-dialog modal-lg modal-fullscreen-sm-down js-freegift-PDP-popup';
      const child1 = element.querySelector('#giftModalcontainer');
      const child2 = element.querySelector('#giftModalwrapper');
      element.classList.add(...modelClass.split(' '));
      child1?.classList.add(...modelClassWrapper.split(' '));
      child2?.classList.add('modal-content');

      const modal = new Modal(element);
      modal.show();
    } else if (selectedGiftGroup > -1) {
      addGiftToCartPayload({
        detail: {
          giftSelected: selectedGifts.map(item => item.replace(/~\d*$/, '')),
          giftGroupIndex: selectedGiftGroup,
        },
      });
    }
  } else if (isRSAItem) {
    rsaCheck();
  } else {
    sendProductCartData();
  }

  // NOTE: Commented the following function call because it was giving
  // double 'Added to Cart' event. [MAVD-20672]
  // setMixpanelData_PDPAddToCart();
};

export const onClickWishlist = (data, isWishList: boolean, wishlistedItemId: string) => {
  data?.detail?.event?.stopPropagation();
  const productCode = data?.detail?.productCode || get(productDetails)?.code;
  isWishList = get(productDetails).inWhishList;
  if (productCode) {
    if (isWishList) {
      removeFromWishlist(wishlistedItemId)
        .then(res => {
          isWishList = false;
          document.querySelector('.js-wishlist-count')!.innerHTML = res.wishlistSize;
          showSnackbar(itemRemoveMsg, 'info');
          productDetails.update(current => {
            return {
              ...current,
              wishlistEntryPk: res.wishlistEntryPk,
              inWhishList: false,
            };
          });
          window['ACC'].extragtm.click.trackRemovedFromWishlist();
        })
        .catch(err => {
          console.error('Error removing from wishlist:', err);
        })
        .finally(() => {
          window['ACC'].loader.hideLoader();
        });
    } else {
      addToWishlist(productCode)
        .then(res => {
          if (res.success === false) {
            window.location.assign(res.redirectUrl);
          } else {
            window['ACC'].extragtm.click.addToWishlistV2();
            isWishList = true;
            setMixpanelData_AddToWishlist();
            document.querySelector('.js-wishlist-count')!.innerHTML = res.wishlistSize;
            showSnackbar(itemAddedMsg, 'info');
            productDetails.update(current => {
              return {
                ...current,
                wishlistEntryPk: res.wishlistEntryPk,
                inWhishList: true,
              };
            });
          }
        })
        .catch(err => {
          console.error('Error adding to wishlist:', err);
        })
        .finally(() => {
          window['ACC'].loader.hideLoader();
        });
    }
  }
};

export const sendBundleCartData = async index => {
  try {
    const requestData = createBundlePayload(index);
    const response = await postAddBundleToCartData(requestData);
    handleCartResponse(response);
  } catch (error) {
    if (error) {
      console.log('failed', error);
    }
  } finally {
    window['ACC'].loader.hideLoader();
  }
};

export function isMiraklSponsoredPDP(): boolean {
  return new URL(window.location.href).searchParams.get('sponsored') === 'true';
}

export function isRMNSourcedPDP(): boolean {
  return new URL(window.location.href).searchParams.get('rmnSource') === 'true';
}
export function getSponsoredFlag_PDP(): string {
  return isMiraklSponsoredPDP() ? 'Yes' : 'No';
}

export function filterOutPromotions(promotions) {
  return (
    promotions &&
    promotions.length > 0 &&
    promotions.filter(p => !p.excludeFromStorefrontDisplay && p.messageType?.length > 0)
  );
}
export function getJoodCardImageUrlNew(priceType: JoodMembershipType, hideNoPrime = false, width = 57) {
  if (priceType === 'NOPRIME' && hideNoPrime) return null;
  if (priceType === 'NOPRIME' && joodExpiredFlag === 'BASIC') {
    return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-blue-card.png?fmt=auto&w=${width}`;
  } else if (priceType === 'NOPRIME' && joodExpiredFlag === 'SMART') {
    return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-card-SMARTPRIME?fmt=auto&w=${width}`;
  }
  if (priceType === 'BASICPRIME') {
    return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-blue-card.png?fmt=auto&w=${width}`;
  }
  if (priceType === 'SMARTPRIME') {
    return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-card-SMARTPRIME?fmt=auto&w=${width}`;
  }
  return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-gold-card.png?fmt=auto&w=${width}`;
}

export function getJoodCardImageUrlAtc(priceType: JoodMembershipType, hideNoPrime = false, width = 57) {
  console.log('getJoodCardImageUrlNew', priceType, hideNoPrime, width);
  if (hideNoPrime) {
    return null;
  }

  if (priceType === 'NOPRIME' && joodExpiredFlag === 'BASIC') {
    return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-blue-card.png?fmt=auto&w=${width}`;
  }

  if (priceType === 'BASICPRIME') {
    return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-blue-card.png?fmt=auto&w=${width}`;
  }

  if (priceType === 'VIPPRIME') {
    return `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}jood-gold-card.png?fmt=auto&w=${width}`;
  }

  return null;
}

export async function getpdpJoodBenefitInfo() {
  const url = `${getBaseWebServiceUrl()}/extra-plus/benefits`;
  const { lang, jessionId } = getAppConfig();
  const params = {
    fields: 'FULL',
    lang,
    deviceId: jessionId,
  };
  const response = await httpGetJSON(url, params, false);
  if (response && !response?.errors?.length) {
    pdpJoodBenefitInfo.set(response);
  } else {
    pdpJoodBenefitInfo.set(null);
  }
}

export function hasDiscoverContent(data: any, flixMediaDataAvailable = false, isTTL24DataAvailable = false) {
  return (
    flixMediaDataAvailable || data?.highlights != null || data?.additionalHighlights != null || isTTL24DataAvailable
  );
}

/**
 * Checks FliX availability once per product/language combination. Components can
 * safely call this independently; concurrent calls share the same request.
 */
export function getFlixMediaDataAvailability(options = {}) {
  const { flixBaseUrl, distributorId, flixmediaLanguage, modelNumber } = {
    ...getAppConfig(),
    ...options,
  };
  const refinedModelNumber = modelNumber?.replace(/\s+/g, '');

  if (!flixBaseUrl || !distributorId || !flixmediaLanguage || !refinedModelNumber) {
    return Promise.resolve(false);
  }

  const url = `${flixBaseUrl}${distributorId}/${flixmediaLanguage}/mpn/${refinedModelNumber}`;
  const existingRequest = flixAvailabilityRequests.get(url);
  if (existingRequest) {
    return existingRequest;
  }

  const request = fetch(url)
    .then(response => response.status === 200)
    .then(isAvailable => {
      flixMediaDataAvailable.set(isAvailable);
      flixMediaDataAvailabilityChecked.set(true);
      return isAvailable;
    })
    .catch(() => false);

  flixAvailabilityRequests.set(url, request);
  return request;
}

export function ensureFlixMediaDataAvailability(data: any) {
  if (data?.highlights != null || data?.highlightsProvider !== 'FLIX') {
    return;
  }

  const { modelNumber } = data;
  const productKey = modelNumber || getAppConfig()?.modelNumber;
  if (!productKey || activeFlixProductKey === productKey) {
    return;
  }

  activeFlixProductKey = productKey;
  flixAvailabilityRequests.clear();
  flixMediaDataAvailable.set(false);
  flixMediaDataAvailabilityChecked.set(false);
  getFlixMediaDataAvailability({ modelNumber: productKey });
}

export function initialize24TtlStream(data: any, modelNumber: string) {
  const { countryCode, lang } = getAppConfig();

  (function (w, d, s, o) {
    const f = d.getElementsByTagName(s)[0];
    const j: any = d.createElement(s);
    (window as any).TTLStreamReady = new Promise(resolve => {
      j.async = true;
      j.src = '//content.24ttl.stream/widget.js';
      f.parentNode.insertBefore(j, f);
      j.onload = function () {
        w.ttlStream = new TTLStream(o);
        resolve(w.ttlStream);
      };
    });
  })(window, document, 'script', {});

  window.TTLStreamReady.then(() => {
    isTTL24DataAvailable.set(true);
    window.ttlStream
      .findAndInsert({
        brand: data?.brandNameEn,
        productId: modelNumber,
        retailerDomain: environment.TTL_24_DOMAIN,
        resultType: 'html',
        contentType: 'minisite',
        el: '#ttl_24-inpage',
        templateType: 'master_template',
        language: `${countryCode.toLowerCase()}_${lang}`,
      })
      .catch(err => {
        console.log('ttl24 content not available::', err);
        isTTL24DataAvailable.set(false);
      });
  });
}
export function getImageAltText(imageUrl?: string): string {
  if (!imageUrl) return 'Product Tile Image';
  const imageFileName = imageUrl?.split('?')[0].split('/').pop();
  const text = imageFileName?.replace(/[^a-zA-Z0-9]+/g, ' ').trim();
  return text;
}

export async function getTamaraPreCheckURL(productCode: string) {
  const webServiceEndpoint = getBaseWebServiceUrl();
  const { APP_ID } = APP_CONSTANTS;
  const tamaraPreCheckUrl = `${webServiceEndpoint}/products/${encodeURIComponent(productCode)}/tamara/prequalification`;
  const { jessionId } = getAppConfig();

  const body = new URLSearchParams({
    appId: APP_ID,
    AppSessionToken: jessionId,
  }).toString();

  return httpPostJSON(tamaraPreCheckUrl, body);
}